import React, { useEffect } from 'react'
import Card from '../../../../components/Card'
import IconButton from '../../../../components/IconButton'
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import Text from '../../../../components/Text'
import { Font } from '../../../../types/Font'
import cx from 'classnames'
import styles from './FontCard.module.css'
import EditFontModal from '../EditFontModal/EditFontModal'
import { openModal } from '../../../../services/ModalService'
import DeleteFontModal from '../DeleteFontModal/DeleteFontModal'
import { showToast } from '../../../../services/ToastService'
import { useTranslation } from 'react-i18next'

const FontCard: React.FC<{
    font: Font
    fonts: Font[]
    onEdit?: (font: Font) => void
    onDelete?: (font: Font) => void
}> = ({ font, fonts, onEdit, onDelete }) => {
    const { t } = useTranslation('settings')
    const openEditModal = (font: Font) => {
        const content: JSX.Element = (
            <EditFontModal
                font={font}
                fonts={fonts}
                onSubmit={() => onEdit?.(font)}
            />
        )
        openModal({ heading: t('fonts.edit_modal.heading'), content: content })
    }

    const openDeleteModal = (font: Font) => {
        const content: JSX.Element = (
            <DeleteFontModal font={font} onSubmit={() => onDelete?.(font)} />
        )
        if (fonts.length > 1) {
            openModal({
                heading: t('fonts.delete_modal.heading'),
                content: content,
            })
        } else {
            showToast(t('fonts.delete_modal.error_last_child'), 'error')
        }
    }

    useEffect(() => {
        if (!font.name || !font.path) return

        const fontFace = new FontFace(font.name, `url(${font.path})`)
        fontFace.load().then((f) => {
            document.fonts.add(f)
        })
    }, [font])

    return (
        <Card>
            <>
                <div className={cx(styles['card-wrapper'])}>
                    <IconButton
                        icon={faEdit}
                        color={'#2f2f2f'}
                        onClick={() => openEditModal(font)}
                    />
                    <IconButton
                        icon={faTrashAlt}
                        color={'#2f2f2f'}
                        onClick={() => openDeleteModal(font)}
                    />
                </div>
                <div className={cx(styles['card-inner-wrapper'])}>
                    <div
                        className={cx(styles['font-family-wrapper'])}
                        style={{ fontFamily: font.name }}
                    >
                        Aa
                    </div>
                    <Text>{font.name}</Text>
                </div>
            </>
        </Card>
    )
}

export default FontCard
